export default __webpack_public_path__ + "static/media/media_blog_image.4172a4da.png";